import { render } from "./NotificationParentEditPane.vue?vue&type=template&id=5247d4b8&scoped=true&ts=true"
import script from "./NotificationParentEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationParentEditPane.vue?vue&type=script&lang=ts"

import "./NotificationParentEditPane.vue?vue&type=style&index=0&id=5247d4b8&lang=css"
import "./NotificationParentEditPane.vue?vue&type=style&index=1&id=5247d4b8&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5247d4b8"]])

export default __exports__